export const APP_CONFIG = APPLICATION_CONFIG; // eslint-disable-line

export const CITY_GRADES_COLLECTION_ID = 'city_avarage_grades';
export const NATIONAL_GRADES_COLLECTION_ID = 'national_avarage_grades';
export const META_COLLECTION_ID = 'metadata';
export const TOPBOTTOM_COLLECTION_ID = 'top_bottom';

export const APP_CONTAINER_CLASS = 'root';
export const APP_CONTAINER_SELECTOR = `.${APP_CONTAINER_CLASS}`;
export const CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
